import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "toggle-right",
  "use": "toggle-right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"toggle-right\">\n<path d=\"M16,20H8c-4.4,0-8-3.6-8-8s3.6-8,8-8h8c4.4,0,8,3.6,8,8S20.4,20,16,20z M8,6c-3.3,0-6,2.7-6,6s2.7,6,6,6h8c3.3,0,6-2.7,6-6\n\ts-2.7-6-6-6H8z\" />\n<path d=\"M16,16c-2.2,0-4-1.8-4-4c0-2.2,1.8-4,4-4s4,1.8,4,4C20,14.2,18.2,16,16,16z M16,10c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2\n\ts2-0.9,2-2C18,10.9,17.1,10,16,10z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol